import { ButtonText } from "components/Atoms/Button";
import React from "react";
import { RemovableLabelList } from "./RemovableLabelList";

interface Props<T> {
  selectedItems: T[]
  onRemove: (newList: T[]) => void
  getId: (item: T) => number | string
  getLabel: (item: T) => string | JSX.Element
}

const MultiPickerSelectedItems = <T extends unknown>(props: React.PropsWithChildren<Props<T>>) => {
  const showSelectedItems = props.selectedItems.length > 0;

  const onRemove = (item: T) => {
    props.onRemove(props.selectedItems.filter(i => props.getId(i) !== props.getId(item)));
  }

  return <>
    {props.children}

    {showSelectedItems && <>
      <RemovableLabelList
        value={props.selectedItems}
        renderLabelContent={props.getLabel}
        getId={props.getId}
        removeItem={onRemove}
      />
      <div className="flex justify-end">
        <ButtonText label={RESX.GeneralLabels.ClearSelection}
          onClick={() => props.onRemove([])}
          style={{ padding: 0 }}
        />
      </div>
    </>}
  </>;
};

export default MultiPickerSelectedItems;